import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  msg = '';

  title = '';

  successButtonText='';
  errorButtonText='';
  
  achCheck= false;
  userRole : string;

  caseNumber: string

  caseCheck : boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) { 
    if (this.data!=null && this.data.Case_Check) {
      this.userRole = this.data.userRole;
      this.caseCheck = true;
    }
  }
  ngOnInit() {

    
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/confirmation-dialog/confirmation-dialog.component.ts